// client/src/components/UI.jsx v3
import { STATUS_META } from '../utils';
import { TrendingUp } from 'lucide-react';

export const MetricCard = ({ title, value, sub, icon: Icon, color = '#3b82f6', onClick }) => (
  <div onClick={onClick} style={{ background:'var(--card-bg)', borderRadius:12, padding:'18px 20px', cursor: onClick ? 'pointer' : 'default',
    border:'1px solid var(--card-border)', transition:'transform 0.1s', position:'relative', overflow:'hidden' }}>
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
      <div style={{ flex:1 }}>
        <p style={{ color:'var(--text-muted)', fontSize:11, margin:'0 0 6px', textTransform:'uppercase', letterSpacing:1 }}>{title}</p>
        <p style={{ color:'var(--text)', fontSize:26, fontWeight:700, margin:0, lineHeight:1 }}>{value ?? '—'}</p>
        {sub && <p style={{ color:'var(--text-muted)', fontSize:11, margin:'6px 0 0' }}>{sub}</p>}
      </div>
      {Icon && (
        <div style={{ width:41, height:41, borderRadius:9, background:`${color}20`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <Icon size={21} color={color} />
        </div>
      )}
    </div>
  </div>
);

export const PremiumMetricCard = ({ title, estimateValue, assetValue, premiumValue, color = '#10b981' }) => (
  <div style={{ background:'var(--card-bg)', borderRadius:12, padding:'18px 20px', border:`1px solid ${color}30` }}>
    <p style={{ color:'var(--text-muted)', fontSize:11, margin:'0 0 10px', textTransform:'uppercase', letterSpacing:1 }}>{title}</p>
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
      <div style={{ display:'flex', justifyContent:'space-between' }}>
        <span style={{ color:'var(--text-muted)', fontSize:12 }}>Estimate</span>
        <span style={{ color:'var(--text)', fontSize:13, fontWeight:500 }}>
          {estimateValue != null ? `£${Number(estimateValue).toLocaleString('en-GB')}` : '—'}
        </span>
      </div>
      {assetValue > 0 && (
        <div style={{ display:'flex', justifyContent:'space-between' }}>
          <span style={{ color:'var(--text-muted)', fontSize:12 }}>Asset Value</span>
          <span style={{ color:'#60a5fa', fontSize:13 }}>+£{Number(assetValue).toLocaleString('en-GB')}</span>
        </div>
      )}
      <div style={{ display:'flex', justifyContent:'space-between', borderTop:`1px solid ${color}30`, paddingTop:6, marginTop:2 }}>
        <span style={{ color:color, fontSize:13, fontWeight:700 }}>Premium</span>
        <span style={{ color:color, fontSize:15, fontWeight:700 }}>
          {premiumValue != null ? `£${Number(premiumValue).toLocaleString('en-GB')}` : '—'}
        </span>
      </div>
    </div>
  </div>
);

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || { bg:'#f3f4f6', text:'#374151' };
  return <span style={{ padding:'2px 8px', borderRadius:20, background:m.bg, color:m.text, fontSize:11, fontWeight:500, whiteSpace:'nowrap' }}>{status}</span>;
};

export const WinRateDisplay = ({ won, decided, size = 'normal' }) => {
  const rate = decided > 0 ? Math.round(won / decided * 100) : null;
  const big = size === 'large';
  return (
    <div>
      <span style={{ color:'var(--text)', fontSize: big ? 28 : 22, fontWeight:700 }}>
        {rate !== null ? `${rate}%` : '—'}
      </span>
      <span style={{ color:'var(--text-muted)', fontSize:11, marginLeft:6 }}>
        {decided > 0 ? `${won}W / ${decided} decided` : 'No decided bids'}
      </span>
    </div>
  );
};

export const Card = ({ children, style }) => (
  <div style={{ background:'var(--card-bg)', borderRadius:12, padding:20, border:'1px solid var(--card-border)', ...style }}>
    {children}
  </div>
);

export const CardTitle = ({ children, action }) => (
  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
    <h3 style={{ color:'var(--text)', margin:0, fontSize:14, fontWeight:600 }}>{children}</h3>
    {action}
  </div>
);

export const TimeFilterBar = ({ value, onChange }) => {
  const filters = [
    { label:'1M', value:'1' },
    { label:'3M', value:'3' },
    { label:'6M', value:'6' },
    { label:'This FY', value:'fy' },
    { label:'12M', value:'12' },
    { label:'All', value:'all' },
  ];
  return (
    <div style={{ display:'flex', gap:4 }}>
      {filters.map(f => (
        <button key={f.value} onClick={() => onChange(f.value)}
          style={{ padding:'4px 10px', borderRadius:6, border:'1px solid', fontSize:11, cursor:'pointer', fontWeight: value===f.value ? 600 : 400,
            borderColor: value===f.value ? '#3b82f6' : 'var(--border)',
            background: value===f.value ? 'rgba(59,130,246,0.15)' : 'transparent',
            color: value===f.value ? '#60a5fa' : 'var(--text-muted)' }}>
          {f.label}
        </button>
      ))}
    </div>
  );
};

export const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{ background:'var(--dropdown-bg)', border:'1px solid var(--border)', borderRadius:8, padding:'10px 14px', fontSize:12, boxShadow:'var(--dropdown-shadow)' }}>
      <p style={{ color:'#cbd5e1', margin:'0 0 6px', fontWeight:600 }}>{label}</p>
      {payload.map((p, i) => (
        <p key={i} style={{ color:'#f1f5f9', margin:'2px 0' }}>
          <span style={{ color: p.color, marginRight:6 }}>●</span>
          {p.name}: <strong>{typeof p.value === 'number' && p.value > 1000 ? `£${p.value.toLocaleString('en-GB', {minimumFractionDigits:2})}` : p.value}</strong>
        </p>
      ))}
    </div>
  );
};
